(function ($) {
    $(function () {

        /**
         * Body element
         *
         * @type Query
         */
        const body = $('body');

        /**
         * Popup element
         *
         * @type jQuery
         */
        const popup = $('#postcode-popup');

        /**
         * Popup inner element
         *
         * @type jQuery
         */
        const inner = $('#postcode-popup-inner');

        /**
         * Popup input
         *
         * @type jQuery
         */
        const input = $('#postcode-popup-input');

        /**
         * Form element
         *
         * @type jQuery
         */
        const form = $('#postcode-popup-form');

        /**
         * Invalid postcode notice element
         *
         * @type jQuery
         */
        const noticeInvalid = popup.find('.alert-invalid');

        /**
         * Undeliverable postcode notice element
         *
         * @type jQuery
         */
        const noticeUndeliverable = popup.find('.alert-undeliverable');

        /**
         * Class used to indicate a page should trigger the popup
         *
         * @type string
         */
        const triggerClass = 'trigger-postcode-popup';

        /**
         * Class used to add loading indicator
         *
         * @type string
         */
        const loadingClass = 'postcode-popup__loading';

        /**
         * Shipping zones and their associated postcodes, loaded from global
         * vars
         *
         * @type array
         */
        const zoneData = dalby.shippingZone.zonePostcodes;

        /**
         * Available shipping zones
         *
         * @type array
         */
        const zones = dalby.shippingZone.zones;

        /**
         * Undeliverable zone
         *
         * @type string
         */
        const zoneUndeliverable = dalby.shippingZone.zoneUndeliverable;

        /**
         * Shipping zones, loaded from global var
         *
         * @type string
         */
        const zoneCookieName = dalby.shippingZone.zoneCookieName;

        /**
         * Shipping zone cookie expiry, loaded from global var (in days)
         *
         * @type string
         */
        const zoneCookieExpiry = dalby.shippingZone.zoneCookieExpiryDays;

        /**
         * Shipping zone cookie domain
         *
         * @type string
         */
        const zoneCookieDomain = dalby.shippingZone.zoneCookieDomain;

        /**
         * Shipping zone cookie secure
         *
         * @type string
         */
        const zoneCookieSsl = dalby.shippingZone.zoneCookieSsl;

        /**
         * Regular expression for matching postcodes including named capture
         * groups
         *
         * @type {RegExp}
         */
        const regex = /^(?<outbound>([A-Z][0-9]{1,2})|(([A-Z][A-HJ-Y][0-9]{1,2})|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9]?[A-Z]))))( ?)(?<inbound>[0-9][A-Za-z]{2})$/;

        /**
         * Is the current page a page that should trigger the popup to load
         *
         * @return boolean
         */
        const isTriggerPage = function() {
            return body.hasClass(triggerClass);
        }

        /**
         * Maybe load the popup if the right conditions are met
         *
         * @return void
         */
        const maybeLoadPopup = function() {
            if (isTriggerPage() && !isValidZone(getZone())) {
                popup.fadeIn(400);
            } else {
                popup.hide();
            }
        }

        /**
         * Check if a zone is a valid shipping zone
         *
         * @param zone
         * @return boolean
         */
        const isValidZone = function(zone) {
            if (zone === null) {
                return false;
            }

            const trimmedZone = zone.replace(/\s/g, '');

            return zones.indexOf(trimmedZone) !== -1;
        }

        /**
         * Check if a postcode is valid
         *
         * @param postcode
         * @return boolean
         */
        const isValidPostcode = function(postcode) {
            if (postcode === null) {
                return false;
            }

            const trimmedPostcode = postcode.replace(/\s/g, '').toUpperCase(); // Remove whitespace

            return regex.test(trimmedPostcode);
        }

        /**
         * Set a cookie
         *
         * @param name
         * @param value
         * @param expirationDays
         * @return void
         *
         * @todo Add secure to cookie and domain
         */
        const setCookie = function(name, value, expirationDays) {
            const date = new Date();
            date.setTime(date.getTime() + (1000 * 60 * 60 * 24 * expirationDays)); // Set expiration time in milliseconds
            const expires = "expires=" + date.toUTCString();
            let secure = '';
            if (zoneCookieSsl) {
                secure = "secure;";
            }
            document.cookie = name + "=" + value + ";" + expires + ";path=/;domain="+zoneCookieDomain+";"+secure+"SameSite=strict";
        }

        /**
         * Get a cookie value
         * @param name
         * @return null|string
         */
        const getCookie = function(name) {
            const cookieString = document.cookie;
            const cookies = cookieString.split(';');

            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();

                if (cookie.startsWith(name + '=')) {
                    return cookie.substring(name.length + 1);
                }
            }

            return null;
        }

        /**
         * Determine a shipping zone from a postcode
         *
         * @param postcode
         * @return string
         */
        function getShippingZoneFromPostcode(postcode) {
            postcode = postcode.toUpperCase();
            for (const zone of zoneData) {
                for (const postcodeLocation of zone.postcodes) {
                    if (isPostcodeMatch(postcode, postcodeLocation)) {
                        return zone.name;
                    }
                }
            }

            return zoneUndeliverable; // No matching zone found for the postcode
        }


        /**
         * Check if a postcode matches a postcode pattern
         *
         * @param postcode
         * @param locationCode
         * @return boolean
         */
        function isPostcodeMatch(postcode, locationCode) {
            const wildcardIndex = locationCode.indexOf('*');

            if (wildcardIndex !== -1) {
                const prefix = locationCode.slice(0, wildcardIndex);

                if (postcode.startsWith(prefix)) {
                    return true;
                }
            } else if (postcode === locationCode) {
                return true;
            }

            return false;
        }

        /**
         * Get the saved zone from cookies
         *
         * @return string|null
         */
        const getZone = function() {
            return getCookie(zoneCookieName)
        }

        /**
         * Validate the form and process the data
         *
         * @param e
         * @return void
         */
        const validateForm = function(e) {
            e.preventDefault();

            // Hide notices
            noticeInvalid.hide();
            noticeUndeliverable.hide();

            const postcode = input.val();

            // Check for valid postcode
            if (!isValidPostcode(postcode)) {
                if (noticeInvalid.not(':visible')) {
                    noticeInvalid.show();
                }

                return;
            }

            // Check for undeliverable
            let zone = getShippingZoneFromPostcode(postcode);

            if (zone === zoneUndeliverable) {
                if (noticeUndeliverable.not(':visible')) {
                    noticeUndeliverable.show();
                }

                return;
            }

            // Made it this far? Set the cookie and continue
            saveAndReload(zone);
        }

        /**
         * Save the data and reload the page
         *
         * @param zone
         * @return void
         */
        const saveAndReload = function(zone)
        {
            setCookie(zoneCookieName, zone, zoneCookieExpiry);

            let height = inner.outerHeight();
            let width = inner.outerWidth();
            inner.css({
                height: height,
                width: width,
            });
            inner.empty().addClass(loadingClass).animate({
                height: '150px',
                width: '150px'
            }, 1000);

            location.reload();
        }

        /**
         * Initialise
         */
        // Attach validation handler
        form.on('submit', validateForm);

        maybeLoadPopup();
    });
})(jQuery);
